export const namePattern = /^[\p{L}\p{M}\p{Zs}.'’-]+$/u;

export const emailPattern = /\S[^\s@]*@\S+\.\S+/;

export const pidPattern = /^\d{1,20}$/;

export const datePattern =
  /^\d{4}[-/.](0[1-9]|1[0-2])[-/.](0[1-9]|[12]\d|3[01])$/;

export const validateSearchValue = (value: string): boolean => {
  if (value === '') {
    return true;
  }

  return (
    namePattern.test(value) || pidPattern.test(value) || datePattern.test(value)
  );
};

export function validateDatePattern(date: string): boolean {
  return datePattern.test(date);
}

export function validateNamePattern(name: string): boolean {
  return namePattern.test(name);
}

export function validateNameLength(name: string): boolean {
  return name.length <= 100;
}

export function validatePID(pid: string): boolean {
  return pidPattern.test(pid);
}

export function validatePIDLength(pid: string): boolean {
  return pid.length <= 20;
}
